import React from 'react';
import { LessonBlock } from '../types';

// A full-width image inside an otherwise-empty card — no title, no body copy.
export default function ImageCard({ block }: { block: LessonBlock }) {
  const image = block.imageEl;
  if (!image) return null;
  return (
    <figure className="pc-lesson-imagecard">
      <img src={image.src} alt={image.alt || block.imageAlt || ''} />
    </figure>
  );
}
